<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/foreword"><span class="item-title-text">Foreword</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">1. </span><span href="#/chapter001" title="Link target outside of Sample"><span class="item-title-text">Limited Choices</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">2. </span><span href="#/chapter002" title="Link target outside of Sample"><span class="item-title-text">No Peace in the Home</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">3. </span><span href="#/chapter003" title="Link target outside of Sample"><span class="item-title-text">Keeping Up Appearances—Or Not</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">4. </span><span href="#/chapter004" title="Link target outside of Sample"><span class="item-title-text">Diminishing Choices</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">5. </span><span href="#/chapter005" title="Link target outside of Sample"><span class="item-title-text">Choices Have Consequences</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">6. </span><span href="#/chapter006" title="Link target outside of Sample"><span class="item-title-text">To Be Healthy or Not to Be</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">7. </span><span href="#/chapter007" title="Link target outside of Sample"><span class="item-title-text">Time’s Up</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">8. </span><span href="#/chapter008" title="Link target outside of Sample"><span class="item-title-text">Choices</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">9. </span><span href="#/chapter009" title="Link target outside of Sample"><span class="item-title-text">False Evidence Appearing Real</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">10. </span><span href="#/chapter010" title="Link target outside of Sample"><span class="item-title-text">Jubilee</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">11. </span><span href="#/chapter011" title="Link target outside of Sample"><span class="item-title-text">Forgiveness</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">12. </span><span href="#/chapter012" title="Link target outside of Sample"><span class="item-title-text">Keeping the Faith</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">13. </span><span href="#/chapter013" title="Link target outside of Sample"><span class="item-title-text">Farewell, My Love</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abigailnabal" title="Link target outside of Sample"><span class="item-title-text">Abigail &amp; Nabal</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/authorsnote" title="Link target outside of Sample"><span class="item-title-text">Author’s Note</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/blacksteel" title="Link target outside of Sample"><span class="item-title-text">Black Steel</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/merryheartsinspirationalseries" title="Link target outside of Sample"><span class="item-title-text">Merry Hearts Inspirational Series</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/heavencanbehell" title="Link target outside of Sample"><span class="item-title-text">Heaven Can Be Hell</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/fireinthewater" title="Link target outside of Sample"><span class="item-title-text">Fire in the Water</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/alsobypatgorgewalker" title="Link target outside of Sample"><span class="item-title-text">Also by Pat G’Orge-Walker</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?07a6c249